import { components } from '@common/types';

type TaskRequirement = components['schemas']['RequirementResponse'];
type TaskRequirementModal = components['schemas']['TaskRequirementModal'];

export const isTaskRequirement = (
  req: TaskRequirement | TaskRequirementModal,
): req is TaskRequirement => {
  return 'field_value' in req;
};
